import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReliabilityObservationSetup from '../components/ReliabilityObservationSetup';
import { fetchStudents } from '../actions/students';
import { doFlash } from '../actions/flash';
import { fetchTeachers } from '../actions/classrooms';
import { createObservation } from '../actions/observations';
import { fetchObservations } from '../actions/observations';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';

const ReliabilityObservationSetupContainer = React.createClass({
	propTypes: {
		classroom: PropTypes.object,
		createObservation: PropTypes.func.isRequired,
		currentObservationId: PropTypes.number,
		fetchObservations: PropTypes.func.isRequired,
		fetchStudents: PropTypes.func.isRequired,
		fetchTeachers: PropTypes.func.isRequired,
		isFetchingObservations: PropTypes.bool,
		isFetchingStudents: PropTypes.bool,
		isFetchingTeachers: PropTypes.bool,
		observations: PropTypes.array,
		students: PropTypes.array,
		teachers: PropTypes.array
	},

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	componentDidMount: function() {
		this.props.fetchObservations();

		if (this.props.classroom) {
			this.fetchStudents(this.props.classroom.id);
			this.props.fetchTeachers(this.props.classroom.id);
		}
	},

	componentWillReceiveProps: function(newProps) {
		if (newProps.classroom && propertyHasChanged(this.props.classroom, newProps.classroom)) {
			this.fetchStudents(newProps.classroom.id);
			this.props.fetchTeachers(newProps.classroom.id);
		}
	},

	fetchStudents: function(classroomId) {
		this.props.fetchStudents({ classroom_id: classroomId, results_per_page: 9999 });
	},

	render: function() {
		return(
			<ReliabilityObservationSetup
				classroom={ this.props.classroom }
				createObservation={ this.props.createObservation }
				currentObservationId={ this.props.currentObservationId }
				fetchObservations={ this.props.fetchObservations }
				isFetchingObservations={ this.props.isFetchingObservations }
				isFetchingStudents={ this.props.isFetchingStudents }
				isFetchingTeachers={ this.props.isFetchingTeachers }
				observations={ this.props.observations }
				router={ this.context.router }
				students={ this.props.students }
				teachers={ this.props.teachers }
			/>
		);
	}
});

let mapStateToProps = function(state) {
	return {
		classroom: state.classrooms.selected,
		currentObservationId: state.observations.currentObservationId,
		isFetchingObservations: state.observations.isFetching,
		isFetchingStudents: state.students.isFetching,
		isFetchingTeachers: state.classrooms.isFetchingTeachers,
		mostRecentObservationId: state.observations.mostRecentObservationId,
		observations: state.observations.list,
		students: state.students.list,
		teachers: state.classrooms.teachers
	};
};

let mapDispatchToProps = {
	createObservation,
	doFlash,
	fetchObservations,
	fetchStudents,
	fetchTeachers
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(ReliabilityObservationSetupContainer);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/ReliabilityObservationSetup.jsx